<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="centerImage"><img alt="images" id="img6" src="images/img6.jpg"/></p>
<p class="caption">Birthplace of the United Indian War Veterans at 901 Charles Street, St. Joseph, Missouri. Members who bolted the National Indian War Veterans convention in September, 1928, reconvened at this address to organize their own body. <em class="italic">Editor’s collection.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IndianWarVeterans_introduction9.vue?08ce31dc